// ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginSelector } from "../../redux/slices/loginSlice";
import { RABC } from "../../utils/RBAC";
import NoPermission from "../noPermission/NoPermission";
import { FC } from "react";

interface ProtectedRouteProps {
    element: FC;
    path: string;
}
  
const ProtectedRoute: FC<ProtectedRouteProps> = ({ element: Component, path }) => {
    const user = useSelector(loginSelector).user;
  
    const routeConfig = RABC.find(item => item.route === path);
    const requiredPermission = routeConfig?.permission;
  
    const hasPermission = requiredPermission ? user?.permissions?.includes(requiredPermission) : true;
  
    return hasPermission ? <Component /> : <NoPermission />;
};

export default ProtectedRoute;